<!-- This provides structure for the app. -->

<!-- Practice header section -->
<div id="practice-header" class="container practice-header">
  <div class="inner-container">
    <eos-practice-header></eos-practice-header>
  </div>
</div>

<!-- Short message section -->
<div id="short-message" class="container short-message">
  <div class="inner-container">
    <eos-short-message></eos-short-message>
  </div>
</div>

<!-- View title section -->
<div
  id="view-title"
  class="container view-title"
  *ngIf="viewTitle && viewTitle.length > 0"
>
  <div class="inner-container">
    <!-- Pass viewTitle to the child component -->
    <eos-view-title-header [viewTitle]="viewTitle"></eos-view-title-header>
  </div>
</div>

<!-- "Body" of the app -->
<div id="router-outlet-content" class="container router-outlet-content">
  <div class="inner-container">
    <router-outlet></router-outlet>
  </div>
</div>
